import { Tooltip } from "react-tooltip";
import { ArrowRightIcon, MagnifyingGlassIcon, UsersIcon } from "@heroicons/react/24/solid";
import { toOrdinal } from "../../../app/utils";
import { DraftStatus } from "../../writing/writingApiSlice";
import { DraftViewModel } from "../scoreReportApiSlice";

interface DraftListProps {
	drafts: DraftViewModel[];
	currentDraft: number;
	status: DraftStatus;
	draftsWithReviews: number[];
	hasLegacyHtmlFormat: boolean;
	showAll: boolean;
	onChangeDraft: (draftId: number) => void;
}

export default function DraftList(props: DraftListProps) {
	function draftSort(a: DraftViewModel, b: DraftViewModel) {
		return b.draftNumber - a.draftNumber;
	}

	function draftLabel(index: number, draft: DraftViewModel) {
		if (index === 0) {
			switch (draft.status) {
				case DraftStatus.Finalized:
					return "Finalized Essay";
				case DraftStatus.Incomplete:
					return "Unsubmitted Draft";
				case DraftStatus.ScoringFailed:
					return "Unscored Draft";
			}

			return draft.hasLegacyHtmlFormat ? "Formatted Essay" : "Latest Draft";
		}
		return `${toOrdinal(draft.draftNumber)} Draft`;
	}

	function draftIcons(draft: DraftViewModel) {
		return (
			<>
				{props.draftsWithReviews?.includes(draft.id) && (
					<>
						<UsersIcon
							className="h-4 inline ml-2 mb-0.5 text-primary-600 outline-none"
							data-tooltip-id="review-tooltip"
						/>
						<Tooltip
							id="review-tooltip"
							place="bottom-start"
							content="Completed Peer Review"></Tooltip>
					</>
				)}
				{draft.hasPlagiarismChecking && (
					<>
						<MagnifyingGlassIcon
							className="h-4 inline ml-2 mb-0.5 text-primary-600 outline-none"
							data-tooltip-id="plagiarism-tooltip"
						/>
						<Tooltip
							id="plagiarism-tooltip"
							place="bottom-start"
							content="Plagiarism Checked"></Tooltip>
					</>
				)}
			</>
		);
	}

	function handleClick(e: React.MouseEvent<HTMLAnchorElement>) {
		const draftId = e.currentTarget.dataset.id;
		props.onChangeDraft(Number(draftId));
	}

	const sorted = props.showAll
		? [...props.drafts].sort(draftSort)
		: [...props.drafts].sort(draftSort).slice(0, 5);

	return (
		<ul>
			{sorted.map((d, index) => {
				const label = draftLabel(index, d);
				if (d.draftNumber == props.currentDraft) {
					return (
						<li key={d.id} id={`draft-${d.id}`} className="font-semibold">
							<ArrowRightIcon className="h-6 inline mr-1" />
							{label}
							{draftIcons(d)}
						</li>
					);
				} else {
					return (
						<li key={d.id} id={`draft-${d.id}`}>
							<a data-id={d.id} onClick={handleClick} className="cursor-pointer">
								{label}
								{draftIcons(d)}
							</a>
						</li>
					);
				}
			})}
		</ul>
	);
}
